var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            width: "70%",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("UM前台显示的基本信息")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "名称（英）:",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "名称（英）不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写名称（英）",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称（中）:", prop: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写名称（中）",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "空间类型",
                            prop: "positionId",
                            rules: [
                              {
                                required: true,
                                message: "空间类型不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-row ai-center" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.handPosition },
                                  model: {
                                    value: _vm.inputForm.positionId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.inputForm, "positionId", $$v)
                                    },
                                    expression: "inputForm.positionId",
                                  },
                                },
                                _vm._l(
                                  _vm.$dictUtils.getDictList("cec_um_space"),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "预估价格",
                            prop: "price",
                            rules: [
                              {
                                required: true,
                                message: "预估价格不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写" },
                            on: {
                              input: function ($event) {
                                return _vm.handleInput($event, "price")
                              },
                              focus: function ($event) {
                                return _vm.focusInput($event, "price")
                              },
                              blur: function ($event) {
                                return _vm.blurInput($event, "price")
                              },
                            },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "状态",
                            prop: "state",
                            rules: [
                              {
                                required: true,
                                message: "状态不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.inputForm.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "state", $$v)
                                },
                                expression: "inputForm.state",
                              },
                            },
                            _vm._l(_vm.stateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "项目数量", prop: "num", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目数量" },
                            model: {
                              value: _vm.inputForm.num,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "num", _vm._n($$v))
                              },
                              expression: "inputForm.num",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标签", prop: "", rules: [] } },
                        [
                          _c("tagSelect", {
                            ref: "tagSelectRef",
                            attrs: {
                              value: _vm.inputForm.tagsIds,
                              associationType: "3",
                            },
                            on: {
                              searchChange: _vm.handSelect,
                              addTagCloud: _vm.addTagCloud,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "简介（英）:",
                            prop: "introductionEn",
                            rules: [
                              {
                                required: true,
                                message: "简介不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写简介内容",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.inputForm.introductionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introductionEn", $$v)
                              },
                              expression: "inputForm.introductionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "简介（中）:", prop: "", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写简介内容",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.inputForm.introductionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introductionCn", $$v)
                              },
                              expression: "inputForm.introductionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "rawStyle", attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "flex-wrap": "wrap" },
                          attrs: { type: "flex" },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-divider",
                                { attrs: { "content-position": "left" } },
                                [_vm._v("后台相关关联信息")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "关联套餐",
                                    prop: "projectSetsId",
                                    rules: [
                                      {
                                        required: true,
                                        message: "关联套餐不能为空",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-row ai-center" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            filterable: "",
                                            placeholder: "请选择关联套餐",
                                          },
                                          on: { change: _vm.handSets },
                                          model: {
                                            value: _vm.inputForm.projectSetsId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputForm,
                                                "projectSetsId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputForm.projectSetsId",
                                          },
                                        },
                                        _vm._l(_vm.dataList, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item ml8",
                                          attrs: {
                                            effect: "dark",
                                            content: "用于关联套餐空间",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-info",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "关联套餐空间",
                                    prop: "setsPositionId",
                                    rules: [
                                      {
                                        required: true,
                                        message: "关联套餐空间不能为空",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-row ai-center" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            filterable: "",
                                            placeholder: "请选择关联套餐空间",
                                          },
                                          on: { change: _vm.handPositionSets },
                                          model: {
                                            value: _vm.inputForm.setsPositionId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputForm,
                                                "setsPositionId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputForm.setsPositionId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.dataPostionList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item ml8",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "用于关联配置空间项目可添加项目",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-info",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "功能空间:",
                            prop: "functionSpacePositionIds",
                            rules: [
                              {
                                required: true,
                                message: "功能空间不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            ref: "gridselectRef",
                            attrs: {
                              title: "选择功能空间",
                              labelName: "nameEn",
                              disabled: _vm.method === "view",
                              showType: "table",
                              labelValue: "id",
                              value: _vm.inputForm.functionSpacePositionIds,
                              limit: 10,
                              columns: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              dataListUrl:
                                "/unmspace/cecUnmFunctionalSpace/list",
                              queryEntityUrl:
                                "/unmspace/cecUnmFunctionalSpace/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.functionSpacePositionIds = value
                              },
                            },
                          }),
                          _c("div", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v("* 功能空间，用于UM空间详情"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      class: _vm.inputForm.showGallery == "0" ? "opacity5" : "",
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "展览集:",
                            prop: "gallery",
                            rules: [
                              {
                                required:
                                  _vm.inputForm.showGallery == "1"
                                    ? true
                                    : false,
                                message: "展览集不能为空",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("ImageUploadDraggableBtn", {
                            attrs: {
                              draggable: true,
                              itemActivityForm: true,
                              ifSetUploadName: true,
                              ownerId: _vm.inputForm.id,
                              uploadInfo: {
                                type: "postionImage",
                                title: "展览集",
                                category: "sets",
                                categoryName: "套餐空间",
                                tip: "请先输入英文名称",
                                fileName: _vm.inputForm.nameEn,
                              },
                              disabled: false,
                              action: "/unmfile/cecUnmFileupload",
                              tip: "单个图片不要超过10M,可拖动列表行排序",
                            },
                            on: {
                              updateChange: function ($event) {
                                return _vm.handImageList($event, "gallery")
                              },
                            },
                            model: {
                              value: _vm.inputForm.gallery,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "gallery", $$v)
                              },
                              expression: "inputForm.gallery",
                            },
                          }),
                          _c("div", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              "* 展览集，用于UM空间详情，展览相关内容， 默认首张图片为列表封面"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "danger",
                    icon: "el-icon-close",
                  },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "medium",
                        type: "success",
                        icon: "el-icon-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }